export default __webpack_public_path__ + "static/media/joomla.4172f124.svg";